import { Component, ViewContainerRef } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { Field } from '../../models/field.interface';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';

@Component({
    selector: 'form-input-date',
    styleUrls: ['form-input-date.component.sass'],
    template: `
    <div class="dynamic-field form-input" [formGroup]="group">
      <mat-form-field appearance="outline">
        <mat-label>{{ config.label }}</mat-label>
        <input
          matInput
          [matDatepicker]="picker"
          [formControlName]="config.name"
          [attr.placeholder]="config.placeholder"
          [disabled]="!!config.disabled || this.typeCes === typeCesEnum.SHOW"
        />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>
  `,
})
export class FormInputDateComponent implements Field {
    config: IFieldConfig;
    group: FormGroup;
    typeCes?: TypeCesEnum | undefined;

    get typeCesEnum() {
        return TypeCesEnum;
    }
} 